import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import withTranslations from '../../utils/HighOrderComponent';
import { rowsPerPageOptions } from '../../constants/globals.js';
import { TablePagination } from '@material-ui/core';
import { changePaginationTextToSerbian } from '../../utils';
import {
  findAllKjsMunicipalityPageable,
  updateKjsWithMunicpality,
  findAllKjsMunicipalityFilterPageable,
} from '../../actions/kjsMunicipality';
import {
  findAllKjsPageable,
  findAllKjsFilterPageable,
  findAllKjs,
  updateKjs,
  clearKjsList,
} from '../../actions/kjs';
import KjsTable from '../Kjs/KjsTable';
import { clearPlaceList, findAllPlace } from '../../actions/place';
import {
  findAllMunicipalityByPlace,
  clearMunicipalityList,
} from '../../actions/municipality';
import { findAllInstitutionType } from '../../actions/institutionType';

class KjsList extends Component {
  componentDidMount() {
    this.props.findAllKjsMunicipalityPageable(0, this.props.pageSize);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.resetData) {
      const postData = {
        tableName: 'kjs_municipality',
        filterCriteria: [{ returnAllSignal: true }],
      };
      this.props.findAllKjsMunicipalityFilterPageable(
        0,
        nextProps.pageSize,
        postData
      );
      nextProps.setResetData(false);
    }
  }

  handleFindAllTrigger = (pageNumber, pageSize) => {
    this.props.findAllKjsMunicipalityPageable(pageNumber, pageSize);
  };

  handlePageChange = (event, value) => {
    const {
      setActivePage,
      postData,
      pageSize,
      findAllKjsMunicipalityPageable,
      findAllKjsMunicipalityFilterPageable,
    } = this.props || {};
    setActivePage(value);
    postData
      ? findAllKjsMunicipalityFilterPageable(value, pageSize, postData)
      : findAllKjsMunicipalityPageable(value, pageSize);
  };

  handleChangeRowsPerPage = (event, value) => {
    const {
      setPageSize,
      setActivePage,
      postData,
      findAllKjsMunicipalityFilterPageable,
    } = this.props || {};
    setPageSize(event.target.value);
    setActivePage(0);
    postData
      ? findAllKjsMunicipalityFilterPageable(0, event.target.value, postData)
      : this.handleFindAllTrigger(0, event.target.value);
  };

  render() {
    const {
        t,
        kjsMunicipality,
        loggedUser,
        syncLoadingStop,
        syncLoadingStart,
        findAllKjsPageable,
        updateKjsWithMunicpality,
        updateKjs,
        findAllKjsMunicipalityPageable,
        placeList,
        municipalityList,
        kjsList,
        institutionTypeList,
        findAllPlace,
        findAllKjs,
        findAllKjsFilterPageable,
        clearPlaceList,
        clearMunicipalityList,
        clearKjsList,
        findAllMunicipalityByPlace,
        activePage,
        pageSize,
      } = this.props || {},
      { kjsWithMunicipalityList, totalElements } = kjsMunicipality || {};

    return (
      <Fragment>
        <KjsTable
          kjsWithMunicipalityList={kjsWithMunicipalityList}
          pageNumber={activePage}
          pageSize={pageSize}
          syncLoadingStop={syncLoadingStop}
          syncLoadingStart={syncLoadingStart}
          findAllKjsPageable={findAllKjsPageable}
          loggedUser={loggedUser}
          updateKjs={updateKjs}
          updateKjsWithMunicpality={updateKjsWithMunicpality}
          findAllKjsMunicipalityPageable={findAllKjsMunicipalityPageable}
          placeList={placeList}
          municipalityList={municipalityList}
          kjsList={kjsList}
          institutionTypeList={institutionTypeList}
          clearPlaceList={clearPlaceList}
          clearMunicipalityList={clearMunicipalityList}
          findAllPlace={findAllPlace}
          findAllKjs={findAllKjs}
          findAllKjsFilterPageable={findAllKjsFilterPageable}
          findAllMunicipalityByPlace={findAllMunicipalityByPlace}
          clearKjsList={clearKjsList}
        />
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <TablePagination
            component="div"
            count={Number(totalElements)}
            page={activePage}
            onPageChange={this.handlePageChange}
            rowsPerPageOptions={rowsPerPageOptions}
            onRowsPerPageChange={this.handleChangeRowsPerPage}
            rowsPerPage={pageSize}
            labelRowsPerPage={t.rowPerPage}
            labelDisplayedRows={(obj) =>
              changePaginationTextToSerbian(obj, t.of)
            }
          />
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  kjsMunicipality: state.kjsMunicipality,
  placeList: state.place.placeList || [],
  municipalityList: state.municipality.municipalityList || [],
  kjsList: state.kjs.kjsList || [],
  institutionTypeList: state.institutionType.institutionTypeList || [],
  loggedUser: state.loggedUser?.loggedUser,
});

const mapDispatchToProps = (dispatch) => {
  return {
    findAllKjsMunicipalityPageable: (pageNumber, pageSize) => {
      dispatch(findAllKjsMunicipalityPageable(pageNumber, pageSize));
    },
    findAllKjsPageable: (pageNumber, pageSize) => {
      dispatch(findAllKjsPageable(pageNumber, pageSize));
    },
    findAllKjsFilterPageable: (
      pageNumber,
      pageSize,
      postData,
      successCallback
    ) => {
      dispatch(
        findAllKjsFilterPageable(
          pageNumber,
          pageSize,
          postData,
          successCallback
        )
      );
    },
    findAllKjsMunicipalityFilterPageable: (
      pageNumber,
      pageSize,
      postData,
      successCallback
    ) => {
      dispatch(
        findAllKjsMunicipalityFilterPageable(
          pageNumber,
          pageSize,
          postData,
          successCallback
        )
      );
    },
    updateKjsWithMunicpality: (kjsWithMunicipality, callback, message) => {
      dispatch(
        updateKjsWithMunicpality(kjsWithMunicipality, callback, message)
      );
    },
    updateKjs: (kjs, callback, message, callback2, signalActivation) => {
      dispatch(updateKjs(kjs, callback, message, callback2, signalActivation));
    },
    findAllMunicipalityByPlace: (placeId) => {
      dispatch(findAllMunicipalityByPlace(placeId));
    },
    findAllPlace: () => {
      dispatch(findAllPlace());
    },
    findAllKjs: () => {
      dispatch(findAllKjs());
    },
    findAllInstitutionType: () => {
      dispatch(findAllInstitutionType());
    },
    clearPlaceList: () => {
      dispatch(clearPlaceList());
    },
    clearMunicipalityList: () => {
      dispatch(clearMunicipalityList());
    },
    clearKjsList: () => {
      dispatch(clearKjsList());
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslations(KjsList, 'KjsList'));
